export default "__VITE_ASSET__CcH5uMSZ__"